import type { ReactNode } from "react";
import { View, type StyleProp, type ViewStyle } from "react-native";
import { EMBER } from "../theme/tokens";
import { Row } from "./Row";

export type ActionRowCardProps = {
  leading?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  onPress?: () => void;
  trailing?: ReactNode;
  accessibilityLabel?: string;
  /** Stable analytics identifier; the row's title may be patient content. */
  action?: string;
  style?: StyleProp<ViewStyle>;
};

/** Shared glass action row used by Care and questionnaire detail screens. */
export function ActionRowCard({
  leading,
  title,
  subtitle,
  onPress,
  trailing,
  accessibilityLabel,
  action = "action_row_card",
  style,
}: ActionRowCardProps) {
  return (
    <Row
      onPress={onPress}
      action={action}
      accessibilityRole={onPress ? "button" : undefined}
      accessibilityLabel={accessibilityLabel}
      title={title}
      subtitle={subtitle}
      leading={
        leading ? (
          <View
            style={{
              width: 38,
              height: 38,
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            {leading}
          </View>
        ) : undefined
      }
      leadingSize={38}
      trailing={trailing}
      chevron={!trailing}
      gap={12}
      borderRadius={18}
      paddingHorizontal={15}
      paddingVertical={13}
      titleStyle={{
        fontSize: 15,
        lineHeight: 18,
        color: EMBER.colors.text,
        fontWeight: "900",
      }}
      subtitleStyle={{
        fontSize: 13,
        lineHeight: 18,
        color: EMBER.colors.textLight,
        marginTop: 2,
      }}
      style={style}
    />
  );
}

export default ActionRowCard;
